import { shrpaApi } from "./axios";

export interface CustomerUploadedPhotos {
  photoIds: Array<string>;
}

export default {
  async getAllCustomerManuallyUploadedMedia(customerId: string): Promise<Array<string>> {
    const { data } = await shrpaApi.get<CustomerUploadedPhotos>(`/photo-gallery/customer/${customerId}`);

    return data.photoIds;
  },
};
